import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiService } from '../../../service/api.service';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-bug-reports',
  standalone: true,
  imports: [CommonModule, MatTableModule, MatButtonModule, MatIconModule, MatExpansionModule, DatePipe],
  templateUrl: './bug-reports.component.html',
  styleUrl: './bug-reports.component.less'
})
export class BugReportsComponent implements OnInit {
  private api = inject(ApiService);
  reports: any[] = [];
  displayedColumns: string[] = ['id', 'user', 'ip', 'date', 'actions'];

  ngOnInit() {
    this.loadReports();
  }

  loadReports() {
    this.api.get('admin/bug_reports.php').subscribe({
      next: (response) => {
        this.reports = response.reports;
      },
      error: (err) => {
        console.error('Failed to load bug reports', err);
      }
    });
  }

  formatErrors(errors: any): string {
    return JSON.stringify(errors, null, 2);
  }
}
